<template>
  <div>
    <ElibraryMain kategori="artikel"></ElibraryMain>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import ElibraryMain from "@/components/public-e-library/ElibraryMain.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: 'ELibraryArtikelView',
  components: {
    AppFooter,
    ElibraryMain
  },
  data() {
    return {

    }
  },
  methods: {
  },
  mounted() {
  }

}
</script>

<style scoped>

</style>